import Base from './condition-base'
import renderFields from './wifi.pug'

export default class Wifi extends Base
  Object.defineProperty this, "label", get: -> @t(".label")

  renderFields: renderFields
